<template>
    <span class="nameMarker" :class="{'atwIssues': hasAtwIssues, isFromRosterAssignment}">
        <slot></slot>
    </span>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component
    export default class NameMarker extends Vue {
        @Prop({type: Boolean}) public hasAtwIssues!: boolean;
        @Prop({type: Boolean}) public isFromRosterAssignment!: boolean;
    }
</script>

<style lang="scss" scoped>
    .nameMarker {
        display: block;
        color: var(--theme-text-color);
        padding: 0.2rem;
        border-radius: 0.625rem;

        &.atwIssues {
            background-color: var(--atw-issues-marker-color);
            color: var(--main-background-color);
        }

        &.isFromRosterAssignment {
            background-color: var(--assigned-to-roster-marker-color);
            color: var(--main-background-color);
        }

        &.active {
            color: var(--theme-text-color);
            background: var(--active-marker-background);
        }
    }
</style>
